import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import ProductCategories from '../../../../../baseComponents/Product/ProductCategories'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../forms/FormRenderer'
import { FormElement, FormRender } from '../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs, getAllGroupVats } from '../../../../../utils/reducers/getters'
import { ProductExtendedTyShort, AddLangIdProductModelType } from '../../../types'

interface ShortMainRightProductWithCategoriesLayoutProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    changeLang: (lang: string) => void
    selectedLang: string
}

const ShortMainRightProductWithCategoriesLayout: React.FC<ShortMainRightProductWithCategoriesLayoutProps> = ({ basicData, userPermissions, changeLang, selectedLang }) => {
    const { t } = useTwinTranslation()
    const groupVats = getAllGroupVats()
    const extraRightFields: FormElement<keyof AddLangIdProductModelType>[] = []
    const haveUpdatePermission = permissionCheck(userPermissions, 'update')
    if (basicData.reference) {
        extraRightFields.push({
            label: t('reference', 'Referencia'),
            name: 'reference',
            component: 'InputWithLabelMargin'
        })
    }

    const rightFields: FormRender<AddLangIdProductModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelect',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                ...extraRightFields,
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {}
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        },
    ]
    const parsedRightFields = valueOrDefaultValue(rightFields, userPermissions, basicData)
    return (
        <div className='flex flex-col w-1/4 notFlexAutoFormRender product_container_right'>
            <FormRenderer sections={parsedRightFields} antiUnsaveTrigger={true} />
            <span className='regular16 mt-25 block'>
                <TwinTrans transKey='categories'>Categorías</TwinTrans>
            </span>
            <ProductCategories selectedCategories={basicData?.parsedCategories || []} productType={basicData.productType} categoryProducts={basicData.CategoriesProducts} readOnly={!haveUpdatePermission} />
        </div>
    )
}

export default ShortMainRightProductWithCategoriesLayout